





























import {Prop, Watch} from "vue-property-decorator";
	import {Component, Vue} from '@/shared/component';

	import {storeVentesTotaux, VenteFilter} from '@/stores/modules/vente';
	
	import CrudList from '@/components/Crud/List.vue';
	import TableHead from '@/components/Paginate/TableHead.vue';
	import TableCell from '@/components/Paginate/TableCell.vue';
	import Checked from '@/components/Checked.vue';
	import {Stored} from "vue-stored-prop-decorator/index";
import {WatchObjectProperties} from "@/shared/decorator";
import {FournisseurFilter} from "@/stores/modules/fournisseur";
	
	@Component({
		components: {
			CrudList,
			TableHead,
			TableCell,
			Checked,
		}
	})
	export default class CrudVenteListTotauxVentes extends Vue {
		
		@Prop({type: Boolean, default: true  }) private paginate;
		@Prop({type: Boolean, default: false }) private dense;
		@Stored(() => storeVentesTotaux) private filters!: VenteFilter;
		
		private storeVentesTotaux = storeVentesTotaux;

		private headers = [];
		private search = '';

		@WatchObjectProperties('filters', VenteFilter)
		private filterWatcher(): void {
			var client = { text: 'Client', value: 'client.name' }
			var essence = { text: 'Essence', value: 'boisType' }
			var longueur = { text: 'Longueur', value: 'longueursVente' }
			var volume = { text: 'Volume total', value: 'volume' }
			this.headers = [];
			if (this.filters.totalParClient) {
				this.headers.push(client)
			}
			if (this.filters.totalParBoisType) {
				this.headers.push(essence)
			}
			if (this.filters.totalParLongueur) {
				this.headers.push(longueur)
			}
			this.headers.push(volume)
		}
	}
